<template>
  <div class="layout-wrapper">
    <el-tag type="warning" class="navigator-tips" v-if="!isChrome"
      ><i class="el-icon-warning"></i
      >建议使用[Chrome]浏览器，否则部分功能无法使用<a
        target="_blank"
        href="https://www.google.cn/chrome/"
        >前往下载</a
      ></el-tag
    >
    <div
      :class="isCollapse ? 'layout-container collapse' : 'layout-container'"
      v-if="!fullScreenMode"
    >
      <div class="layout-aside-wrap">
        <AsideCom />
      </div>
      <div class="layout-main-wrap">
        <div class="layout-head-wrap">
          <HeadCom />
        </div>
        <div class="layout-content-wrap">
          <div class="layout-content" id="layout-content">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 100%" v-else>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import AsideCom from "./aside/index.vue";
import HeadCom from "./head.vue";
import eventBus from "@/utils/bus";
import { PageModule } from "@/store/module/page";
export default {
  name: "layout",
  components: { AsideCom, HeadCom },
  data() {
    return {
      asideOpen: false,
      isCollapse: false,
      isChrome: true,
    };
  },
  computed: {
    fullScreenMode() {
      // 隐藏顶栏侧栏的全屏模式
      return PageModule.layoutFullScreenMode;
    },
  },
  created() {
    eventBus.$on("collapse", (item) => {
      this.isCollapse = item;
    });
    eventBus.$on("layout-scroll-top", () => {
      window.document.getElementById("layout-content")?.scroll(0, 0);
    });
    let navigatorPass = true;
    if (window.navigator.userAgent.indexOf("lbbrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("QQBrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("maxthon") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("bidubrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("Firefox") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("Chrome") < 0) {
      navigatorPass = false;
    }
    this.isChrome = navigatorPass;
  },
  beforeDestroy() {
    eventBus.$off("collapse");
    eventBus.$off("layout-scroll-top");
  },
};
</script>
<style lang="scss" scoped>
.layout-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  .navigator-tips {
    display: block;
    text-align: center;
    i {
      margin-right: 6px;
    }
    a {
      margin-left: 6px;
      color: #e6a23c;
      text-decoration: underline;
    }
  }
  .layout-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    .layout-aside-wrap {
      border-right: 1px solid #eef3f6;
    }
    .layout-main-wrap {
      flex: 1;
      background-color: #eef3f6;
      display: flex;
      flex-direction: column;
      .layout-head-wrap {
        height: 42px;
        border-bottom: 1px solid #eef3f6;
        background-color: #ffffff;
      }
      .layout-content-wrap {
        flex: 1;
        border-radius: 4px;
        margin: 12px;
        position: relative;
        .layout-content {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          overflow-y: auto;
          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-track {
            width: 4px;
            background: none;
          }
          &::-webkit-scrollbar-thumb {
            width: 4px;
            background: #d8d8d8;
            border-radius: 2px;
          }
        }
      }
    }
    &.collapse {
      .layout-aside-wrap {
        width: 53px;
      }
    }
  }
}
</style>
